import { createSlice } from "@reduxjs/toolkit";

interface FeedSwitchTabOverlay {
    open: boolean;
}

const initialState: FeedSwitchTabOverlay = {
    open: false,
};

const feedSwitchTabOverlay = createSlice({
    name: "feedSwitchTabOverlay",
    initialState,
    reducers: {
        openFeedSwitchTabOverlay(state): void {
            state.open = true;
        },
        closeFeedSwitchTabOverlay(state): void {
            state.open = false;
        },
    },
});

// Extract the action creators object and the reducer
const { actions, reducer } = feedSwitchTabOverlay;
// Extract and export each action creator by name
export const { openFeedSwitchTabOverlay, closeFeedSwitchTabOverlay } = actions;
// Export the reducer, either as a default or named export
export default reducer;
